(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["naturelia-home"] && !Shopify.designMode) return;
  try {
    
function natureliaPlanner(){const input=document.getElementById('nat-guests');if(!input)return;const update=()=>{const guests=Number(input.value);if(!Number.isInteger(guests)||guests<1||guests>2400)return;const packs=Math.ceil(guests/24);document.getElementById('nat-packs').textContent=packs;document.getElementById('nat-plates').textContent=packs*24;document.getElementById('nat-total').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-CA',{style:'currency',currency:input.dataset.currency||'CAD'}).format(packs*Number(input.dataset.price)/100);};input.addEventListener('input',update);update();}
natureliaPlanner();document.addEventListener('shopify:section:load',natureliaPlanner);

const offerPanel = document.querySelector('[data-nat-offer-end]');
if (offerPanel) {
  const remaining = Date.parse(offerPanel.dataset.natOfferEnd) - Date.now();
  if (remaining <= 0) offerPanel.remove();
  else window.setTimeout(() => offerPanel.remove(), remaining);
}

  } catch(e) { console.error(e); }
})();
})();
